import React, { useEffect, useState } from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { useLocation } from "react-router";
import { WriteReview } from "@organisms";
import { getGraphqlIdFromDBId } from "@utils";
import { history } from "@src/history";
import { baseUrl } from "@src/app/routes";

const WriteReviewPage: React.FC<IProps> = ({
  // destructure props here if needed
}: IProps) => {
  const location = useLocation();
  const paths = location.pathname.split('/').filter(
    (path, idx) => {
      return path !== "";
    })
  const productDbId = paths[paths.length-1];
  const productId = getGraphqlIdFromDBId(productDbId, "Product");
  const [pendingRedirect, setPendingRedirect] = useState(true);

  useEffect(() => {
    if (!pendingRedirect) {
      history.push(baseUrl);
    }
  }, [pendingRedirect])

  return (
    <WriteReview
      productId={productId}
      setShowWriteReview={setPendingRedirect}
      setReviewStatus={() => {}}
    />
  )
};

export { WriteReviewPage }